import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { company, supportCards } from '../data/company';
import { ButtonLink } from './ButtonLink';
import { Card, CardTag } from './Card';
import { Section } from './Section';
export function SupportSection() {
  return <Section id="soporte" number="07" title="Atención al cliente" subtitle="Atendemos consultas antes de la compra, problemas de descarga, dudas sobre un cargo y pedidos de reembolso. Respondemos todos los mensajes." data-id="element-155" data-mp="186arto3hickn">
      <div className="mb-7 rounded-[18px] border border-accent-soft/35 bg-accent/10 px-5 py-9 text-center md:px-7" data-id="element-156" data-mp="1hvarzatq3e0f">
        <h3 className="mb-3 text-2xl font-bold tracking-[-0.01em] text-fg" data-id="element-157" data-mp="1vv2b1pz3jkla">¿Necesitás ayuda? Escribinos.</h3>
        <p className="mx-auto mb-5 max-w-[620px] leading-relaxed text-body" data-id="element-158" data-mp="1rs5mzjqsew9y">
          Nuestro canal principal de soporte es el email. Respondemos dentro de las <strong className="font-bold text-fg" data-id="element-159" data-mp="3tmes63s2s4xm">24 horas hábiles</strong>.
          También podés llamarnos por teléfono en horario de atención.
        </p>
        <div className="flex flex-wrap justify-center gap-3" data-id="element-160" data-mp="17rehe8xumwpx">
          <ButtonLink href={company.supportMailto} data-id="element-161" data-mp="1ct3q3hxlmyau">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-162" data-mp="1hrovdvrpk865" />
            Escribir a {company.email}
          </ButtonLink>
          <ButtonLink href={company.phoneHref} variant="ghost" data-id="element-163" data-mp="1miex8z0xdsw3">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-164" data-mp="1rh8ff4r5q82l" />
            {company.phone}
          </ButtonLink>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-165" data-mp="1vhsb03w313mm">
        {supportCards.map(card => <Card key={card.tag} data-id="element-166" data-mp="20ig0gl4nxceq">
            <CardTag data-id="element-167" data-mp="20g3msk5xto7h">{card.tag}</CardTag>
            <p className="my-1.5 break-words text-[17px] font-bold text-fg" data-id="element-168" data-mp="25h9bm6wh8rbq">
              {card.href ? <a href={card.href} className="text-accent-soft hover:underline" data-id="element-169" data-mp="64x43emdbzv0">
                  {card.value}
                </a> : card.value}
            </p>
            <p className="text-[14.5px] leading-relaxed text-muted" data-id="element-170" data-mp="3328knmp7qr5">{card.description}</p>
          </Card>)}
      </div>
    </Section>;
}